import { palette } from "../theme";

// Stile icon-button allineato a Aggregations (tableHosts): bordo sottile,
// bordo primary quando il filtro è attivo.
export const toolIconSx = (active = false) => ({
  width: 34,
  height: 34,
  color: "#eaeaea",
  border: "1px solid",
  borderColor: active ? palette.primary.main : "rgba(255,255,255,0.14)",
  borderRadius: "8px",
  "&:hover": { borderColor: palette.primary.light, backgroundColor: "rgba(69,144,149,0.12)" },
});
